import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-right",
  "use": "app-icon-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-right\"><path d=\"M5.081 14.086a.6.6 0 01-.063-.774l.063-.074 5.233-5.233L5.08 2.773a.6.6 0 01-.063-.774l.063-.075a.6.6 0 01.774-.063l.075.063 5.657 5.657a.6.6 0 01.063.774l-.063.075-5.657 5.656a.6.6 0 01-.849 0z\" fill=\"#4D4D4D\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol